import { useState } from 'react';
import { uniqueId } from 'lodash';
import { toastAlert } from '../components/Toastify/index';
import { useDispatch } from 'react-redux';
import {
  getLogFiles,
  uploadLogFile,
  removeLogFile,
} from '../state/files/slice';
import filesize from 'filesize';
import api from '../services/api';

export function useFileAPI(callback = null) {
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState('idle');

  const dispatch = useDispatch();

  const handleUpload = (items, { id, tenantId, type = 'task' }) => {
    const uploadedFiles = items.map((file) => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      progress: 0,
      uploaded: false,
      error: false,
      url: null,
    }));

    uploadedFiles.forEach(async (item) => {
      const data = new FormData();

      data.append('file', item.file, item.name);
      data.append('originalId', id);
      data.append('type', type);
      data.append('tenantId', tenantId);

      api
        .post('/activedflows/new-file', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (e) => {
            //const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          },
        })
        .then((response) => {
          const data = response.data;

          dispatch(
            uploadLogFile({
              file: {
                _id: data._id,
                name: data.name,
                url: data.url,
                readableSize: filesize(data.size),
              },
              id,
            })
          );

          if (callback) callback('add');

          setFiles([
            ...files,
            {
              _id: data._id,
              name: data.name,
              url: data.url,
              readableSize: filesize(data.size),
            },
          ]);
        })
        .catch((error) => {
          toastAlert({
            msg: `Ocorreu um erro ao enviar o arquivo: ${error.message}`,
            isError: true,
          });
        });
    });
  };

  const handleDelete = async ({ fileId, id }) => {
    const response = await api.delete(`activedflows/remove-file/${fileId}`);

    if (response.status === 200) {
      dispatch(removeLogFile({ fileId, id }));
      setFiles((files) => files.filter((file) => file._id !== fileId));

      if (callback) callback('remove');
    }
  };

  async function fetchFiles(id) {
    const response = await api.get(`/activedflows/files/${id}`);

    if (response.status === 200) {
      const files = await response.data.map((file) => ({
        _id: file._id,
        name: file.name,
        readableSize: filesize(file.size),
        preview: file.url,
        uploaded: true,
        url: file.url,
      }));

      setFiles(files);
      dispatch(getLogFiles({ files, id }));
      setStatus('succeeded');
      // if (callback) callback('update');
    }
  }

  return { handleUpload, handleDelete, files, status, fetchFiles };
}
